/**
 * URL parameters that will be tracked for changes
 */
export const TRACK_CHANGES = [
  'SRC',
  'subid',
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_content',
  'utm_term',
  'MSCLKID',
  'iv',
  'gclid',
  'agent_id',
];

/**
 * Maps URL keys with different name as the properties in the `hc` object
 */
export const MAP_KEYS = {
  SRC: 'source',
  iv: 'bt_sid',
  MSCLKID: 'msclkid',
};
